import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "可預訂場地", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("small", null, "五分鐘內有人嘗試預訂", -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("small", null, "選擇場地後，本平台會協助您預約", -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HintIcon = _resolveComponent("HintIcon")!
  const _component_Arrow = _resolveComponent("Arrow")!
  const _component_ScrollWrap = _resolveComponent("ScrollWrap")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.bookingBlock)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.subheading)
    }, [
      _hoisted_1,
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.hint, _ctx.allowBooking ? _ctx.$style.blue : _ctx.$style.red])
      }, [
        (_ctx.hasHint)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_HintIcon),
              _hoisted_2
            ], 64))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    (!_ctx.allowBooking)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.$style.alert)
        }, " 請使用場館 App、電話或臨櫃預約 ", 2))
      : _createCommentVNode("", true),
    _createVNode(_component_ScrollWrap, {
      class: _normalizeClass(_ctx.$style.bookingInfo),
      hasLoading: !Object.keys(_ctx.courtsData).length
    }, {
      default: _withCtx(() => [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courtsData, (court, i) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass([
            court.courtId === _ctx.cntCourtId && _ctx.$style.selected,
            court.status !== 'idle' && 'disable',
          ]),
              key: i,
              onClick: ($event: any) => (court.status === 'idle' && _ctx.selectCourt(court))
            }, [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(court.courtName) + " ", 1),
                (court.clicked)
                  ? (_openBlock(), _createBlock(_component_HintIcon, {
                      key: 0,
                      class: _normalizeClass(_ctx.$style.hint)
                    }, null, 8, ["class"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_Arrow, {
                style: _normalizeStyle({ transform: 'rotate(-90deg)' })
              }, null, 8, ["style"])
            ], 10, _hoisted_3))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["class", "hasLoading"]),
    (_ctx.allowBooking)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true)
  ], 2))
}